/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    4000: "La journée d'exploitation n'est pas active.",
    4001: "Le gestionnaire de ligne n'est pas actif.",
    4002: "Il manque une donnée dans le gestionnaire de ligne.",
    4003: "L'identifiant SAE de la DSP n'est pas correct.",
    4004: "La DSP n'est pas active sur la journée."
};